import { Outlet } from 'react-router-dom';
import McpChatOnboardingModal from './components/onboarding/McpChatOnboardingModal';
import { McpChatOnboardingProvider } from './hooks/McpChatOnboardingContext';

/**
 * Wraps all /chat/* routes. Chat UI is always visible; incomplete setup opens
 * in a modal when the user tries to chat (`completed` gates real usage).
 */
const McpLayout = () => {
  return (
    <McpChatOnboardingProvider>
      <Outlet />
      <McpChatOnboardingModal />
    </McpChatOnboardingProvider>
  );
};

export default McpLayout;
